import Dialog from "../../../../../components/dialogs/Dialog";
import DialogTitle from "../../../../../components/dialogs/DialogTitle";
import {_transl} from "../../../../../store/localization/TranslMessasge";
import {UsersTranslationKey} from "../UsersTranslationKey";
import DialogContent from "../../../../../components/dialogs/DialogContent";
import Grid from "../../../../../components/dialogs/Grid";
import DialogActions from "../../../../../components/dialogs/DialogActions";
import {SaveButton} from "../../../../../components/button/SaveButton";
import {CancelButton} from "../../../../../components/button/CancelButton";
import React, {useEffect, useState} from "react";
import collectionsService from "../../collections/service/CollectionsService";
import userService from "../../../../../common/apis/user/UserApiClient";
import {CollectionPermissionLevelDto} from "../../../../../common/apis/user/CollectionPermissionLevelDto";
import {CommonTranslationKey} from "../../CommonTranslationKey";
import {CollectionDto} from "../../../../../common/apis/collection/CollectionDto";
import Snackbar from "../../snackbar/Snackbar";
import SingleSelectField from "../../../../../components/fields/select/SingleSelectField";

interface UserPermissionCreateDialogProps {
    login: string,
    onClose: () => void,
    reloadUserPermissionsGrid: () => void,
}

export default function UserPermissionCreateDialog(props: UserPermissionCreateDialogProps) {
    const {login, reloadUserPermissionsGrid, onClose} = props;

    const [collections, setCollections] = useState<CollectionDto[]>([]);
    const [permissions, setPermissions] = useState<CollectionPermissionLevelDto[]>([]);

    const [isUnsuccessfullyValidated, setUnsuccessfullyValidated] = useState<boolean>(false);
    const [collection, setCollection] = useState<CollectionDto | undefined>(undefined);
    const [permission, setPermission] = useState<CollectionPermissionLevelDto | undefined>(undefined);
    const [collectionError, setCollectionError] = useState<string | undefined>(undefined);
    const [permissionError, setPermissionError] = useState<string | undefined>(undefined);

    useEffect(() => {
        const fetchCollectionsAndPermissions = async () => {
            const collections = await getCollections();
            const permissions = await getPermissions();
            setCollections(collections);
            setPermissions(permissions);
        }
        fetchCollectionsAndPermissions();
    }, []);

    const getCollections = async (): Promise<CollectionDto[]> => {
        try {
            const collections = await collectionsService.getAll();
            return collections;
        } catch (error) {
            return [];
        }
    }

    const getPermissions = async (): Promise<CollectionPermissionLevelDto[]> => {
        try {
            const permissions = await userService.getAllPermissionLevels();
            return permissions;
        } catch (error) {
            return [];
        }
    }

    function validatePermission(permission: CollectionPermissionLevelDto | undefined | null): boolean {
        if (permission) {
            setPermissionError(undefined);
            return true;
        } else {
            setPermissionError(_transl(CommonTranslationKey.FILL_OUT_THIS_FIELD));
            return false;
        }
    }

    function validateCollection(collection: CollectionDto | undefined | null): boolean {
        if (collection) {
            setCollectionError(undefined)
            return true;

        } else {
            setCollectionError(_transl(CommonTranslationKey.FILL_OUT_THIS_FIELD));
            return false;
        }
    }

    function isFormValid() {
        const isPermissionValid = validatePermission(permission);
        const isCollectionValid = validateCollection(collection);
        return isPermissionValid && isCollectionValid;
    }

    function onDialogSave() {
        setUnsuccessfullyValidated(true)
        if (isFormValid()) {
            (async () => {
                try {
                    await userService.createUserCollectionPermission(login, collection!.code, permission!.code);
                    onClose();
                    reloadUserPermissionsGrid();
                    Snackbar.success(_transl(UsersTranslationKey.CREATE_PERMISSION_SUCCEEDED));
                } catch (e) {
                    Snackbar.error(_transl(UsersTranslationKey.CREATE_PERMISSION_FAILED));
                }
            })();
        }
    }

    return (
        <Dialog open onClose={onClose}>
            <DialogTitle id="scroll-dialog-title"
                         title={_transl(UsersTranslationKey.ADD_PERMISSION_DIALOG)}
                         onDialogClosed={onClose}/>

            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <SingleSelectField<CollectionDto>
                            id="collection-field"
                            label={_transl(UsersTranslationKey.ADD_PERMISSION_COLLECTION)}
                            errorMessage={collectionError}
                            value={collection ?? null}
                            onChange={(coll) => {
                                isUnsuccessfullyValidated && validateCollection(coll);
                                setCollection(coll ?? undefined);
                            }}
                            options={collections}
                            getOptionLabel={(collection: CollectionDto) => collection.name}
                            required={true}/>

                    </Grid>
                    <Grid item xs={12}>
                        <SingleSelectField<CollectionPermissionLevelDto>
                            id="userPermission-field"
                            label={_transl(UsersTranslationKey.ADD_PERMISSION_PERMISSION_LEVEL)}
                            errorMessage={permissionError}
                            value={permission ?? null}
                            onChange={(perm) => {
                                isUnsuccessfullyValidated && validatePermission(perm);
                                setPermission(perm ?? undefined);
                            }}
                            options={permissions}
                            getOptionLabel={(permission: CollectionPermissionLevelDto) => _transl(permission.translationKey)}
                            required={true}/>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <SaveButton onClick={onDialogSave}/>
                <CancelButton onClick={onClose}/>
            </DialogActions>

        </Dialog>
    );
}
